<template>
  <AbsPopup id="OpenImage" title="이미지" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div class="message" v-html="message">
        </div>
        <img :src="image" alt="">
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    this.image = this.option.param.image
    this.message = this.option.param.message
    this.$emit('loading', false)
  },
  data: () => {
    return {
      image: '',
      message: ''
    }
  },
  name: 'OpenImage',
  computed: {
  },
  methods: {
    submit () {
      this.$emit('submit', this.link)
    }
  },
  components: {
    AbsPopup
  }
}
</script>

<style scoped>
.popup-body .message {
  display: flex;
  padding: 20px;
  font-size: 2em;
  align-items: center;
  justify-content: space-around;
  border-bottom: 2px solid var(--require);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/OpenImage.vue